// eslint-disable-next-line import/no-extraneous-dependencies
import styled from 'styled-components';
export const MainContainer = styled.div `
  .root-app_layout {
    width: 100%;
    position: relative;

    .root-app_loading-container {
      z-index: 9999;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      position: fixed;
    }

    .root-app_env-label-container {
      width: 100%;
      height: var(--env-label-height);
    }

    .root-app_content {
      .root-app_menu {
        &.hidden {
          display: none;
        }
        &.menu-v1 {
          top: 0;
          position: fixed;
          width: var(--menu-v1-width);
        }
      }
    }
  }
`;
//# sourceMappingURL=style.js.map